import { useEffect, useState } from "react";
import { ActionFormSize, FormDisplayOptions } from "@cayo/shared/api/types/schema/form";
import { useWindowSize } from "../GlobalHooks/useWindowSize";

const DIALOG_MIN_HEIGHT = 120;

interface IDialogSize {
  width: number;
  height: number;
  isMaximized: boolean;
}

export const useDialogSize = (size: FormDisplayOptions["size"]) => {
  const { width, height } = useWindowSize();

  const [dialogSize, setDialogSize] = useState<IDialogSize>({
    width: ActionFormSize[size || "md"],
    height: DIALOG_MIN_HEIGHT,
    isMaximized: false,
  });

  useEffect(() => {
    // keep maximized dialog size according to browser window size
    if (dialogSize.isMaximized) {
      setDialogSize({ width, height, isMaximized: true });
    }
    // keep windowed dialog width according to browser window width
    else if (size && width !== 0 && width < ActionFormSize[size]) {
      setDialogSize({ width, height: DIALOG_MIN_HEIGHT, isMaximized: false });
    }
  }, [width, height]);

  const handleMaximize = () => {
    // to window
    if (dialogSize.isMaximized) {
      if (size) {
        if (width > ActionFormSize[size]) {
          setDialogSize({
            width: ActionFormSize[size],
            height: DIALOG_MIN_HEIGHT,
            isMaximized: false,
          });
        } else {
          setDialogSize({ width, height: DIALOG_MIN_HEIGHT, isMaximized: false });
        }
      } else {
        setDialogSize({ width: ActionFormSize.md, height: DIALOG_MIN_HEIGHT, isMaximized: false });
      }
    }
    // to fullscreen
    else {
      setDialogSize({ width, height, isMaximized: true });
    }
  };

  return { dialogSize, handleMaximize };
};
